import React, {Component, ReactNode} from 'react';
import './CompletionPopup.scss';
import {
    Button,
    Dialog, DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Stack, Typography
} from '@mui/material';
import {GameContext, Guess} from '../content/GameContext';
import {ResultsSharer} from './ResultsSharer';
import {Close} from '@mui/icons-material';
import ResultTable from '../resulttable/ResultTable';

export interface CompletionPopupProps<Schema> {
    show: boolean;
    successful: boolean;
    onClose: () => void;
    gameContext: GameContext<Schema>;
    guesses: Guess<Schema>[];
}

export class CompletionPopup<Schema> extends Component<CompletionPopupProps<Schema>> {
    private sharer: ResultsSharer<Schema>;

    constructor(props: CompletionPopupProps<Schema>) {
        super(props);
        this.sharer = new ResultsSharer(props.gameContext);
        this.onCopyToClipboardClick = this.onCopyToClipboardClick.bind(this);
    }

    private onCopyToClipboardClick() {
        this.sharer.copyToClipboard(this.props.guesses);
    }

    private createResultRow() {
        const actual = this.props.gameContext.getActualDisplayProperties();
        return <ResultTable columns={this.props.gameContext.getColumnDetails(true)}
                            rows={actual}
                            widths={this.props.gameContext.getColumnWidths(true)}/>;
    }

    private createContent() {
        const actual = this.props.gameContext.getActualResultInformation();
        const message1 = this.props.successful ? "CONGRATULATIONS ON WINNING" : "You didn't win :(";
        return <Stack
            direction="column"
            divider={<Divider orientation="horizontal" flexItem sx={{background: "primary.main"}}/>}
            spacing={2}
            alignItems={"center"}
            paddingX={"8"}
        >
            <img style={{minHeight: 160, minWidth: 160, maxHeight: 240}} src={actual[1]} alt={actual[0]}
                 title={actual[0]}/>
            <Stack direction="column"
                   spacing={2}>
                <Typography id="modal-modal-description" variant={"subtitle1"} align={"center"} color={"primary"}>
                    {message1}
                </Typography>
                <Typography id="modal-modal-title" variant={"h3"} align={"center"} color={"primary"}>
                    {actual[0]}
                </Typography>
                {
                    this.props.successful ?
                        <Typography id="modal-modal-description" variant={"subtitle1"} align={"center"}
                                    color={"primary"}>
                            You got it in {this.props.guesses.length} tries!
                        </Typography> : this.createResultRow()
                }
            </Stack>
            <Stack direction="row">
                <Button onClick={this.onCopyToClipboardClick}>Copy To Clipboard</Button>
            </Stack>
        </Stack>;
    }

    override render(): ReactNode {
        return <Dialog
            open={this.props.show}
            fullWidth
            maxWidth={false}
            sx={{width: "100%", maxWidth: "800px", margin: "auto"}}
        >
            <DialogTitle>
                <IconButton aria-label="close" onClick={this.props.onClose} sx={{
                    position: 'absolute',
                    right: 4,
                    top: 4,
                    color: "primary.main"
                }}>
                    <Close/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {this.createContent()}
            </DialogContent>
        </Dialog>;
    }
}
